interface Section {
  id: string;
  label: string;
}

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export function StickyNav({ sections }: { sections: Section[] }) {
  return (
    <nav
      aria-label="Playbook sections"
      className="sticky top-16 z-30 -mx-4 mb-4 flex flex-wrap gap-x-4 gap-y-1 border-b border-gold-400/20 bg-ink-950/90 px-4 py-1.5 backdrop-blur"
    >
      {sections.map((s) => (
        <button
          key={s.id}
          type="button"
          onClick={() => scrollToId(s.id)}
          className="font-display text-[11px] uppercase tracking-[0.22em] text-parchment-100/70 hover:text-gold-300"
        >
          {s.label}
        </button>
      ))}
    </nav>
  );
}
